import React, { useState, useContext, createContext } from "react";
import api from "../services/api";

export const visibilityContext = createContext();

function useVisibilityProvider() {
  const [pinnedTabs, setPinnedTabs] = useState([]);

  const savePinnedTabs = (tabs) => {
    setPinnedTabs(tabs);
    api.savePinnedTabs(tabs);
  };

  return {
    pinnedTabs,
    setPinnedTabs,
    savePinnedTabs,
  };
}

export function ProvideVisibility({ children }) {
  const values = useVisibilityProvider();
  return <visibilityContext.Provider value={values}>{children}</visibilityContext.Provider>;
}

export const useVisibility = () => {
  return useContext(visibilityContext);
};
